{
    "FormEngineSetterWfl": {
        "title": "Setter",
        "description": "Mutate the local variable stack"
    },
    "mask": {
        "FormEngineSetterWfl": {
            "groupTitle": "Setter",
            "assignments": "Assignments"
        }
    }
}